import './streamResponseRecorderGlobals';

/**
 * Resets the stream response recording for a new stream session.
 * Should be called at the start of each `processStream` invocation.
 */
export const resetStreamResponseRecording = (): void => {
	try {
		if (window.top) {
			window.top.__rovoStreamResponseMessages__ = [];
		}
	} catch {
		// Ignore cross-origin frame access errors
	}
};
